import cls from 'classnames';
import { selectTranslator } from 'core/redux/features/languages/trans';
import { selectActiveProductInfo } from 'core/redux/features/products/reducers/productInfos';
import { selectActiveProduct } from 'core/redux/features/products/reducers/products';
import { IProduct, IProductInfo } from 'core/redux/features/products/types';
import { AppState } from 'core/redux/reducers';
import React, { HTMLAttributes } from 'react';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState) => ({
  product: selectActiveProduct(state),
  info: selectActiveProductInfo(state),
  trans: selectTranslator(state),
});

interface ProductAddressProps
  extends Partial<HTMLAttributes<HTMLParagraphElement>> {
  product: IProduct | IProductInfo | null;
}
export function ProductAddress({
  product,
  className,
  ...htmlAttr
}: ProductAddressProps) {
  return (
    <p {...htmlAttr} className={cls('label', className)}>
      {(product as IProduct)?.city_address}
    </p>
  );
}

export function ProductDetailedLocation({
  product,
  className,
  ...htmlAttr
}: ProductAddressProps) {
  return (
    <p
      {...htmlAttr}
      className={cls('product__desc product__desc--address', className)}
    >
      {(product as IProductInfo)?.detailed_location}
    </p>
  );
}

interface IProps {
  showMap?: boolean;
  showLabel?: boolean;
  iconClass?: string;
  mapOnly?: boolean;
  onClickTitle?: (e: React.MouseEvent<HTMLElement>) => void;
}

type TProps = IProps & ReturnType<typeof mapStateToProps>;

function createGoogleMapLink(product: IProduct, address: string) {
  const zoom = 17;
  const geo = `${product.geo.lat},${product.geo.lng}`;
  return `//www.google.com/maps/place/${address}/@${geo},${zoom}z`;
}

export function AddressWithMapComp({
  product,
  info,
  showMap,
  showLabel,
  //   iconClass,
  mapOnly,
  trans,
  //   onClickTitle,
}: TProps) {
  if (!product || !info || !info.address || !product?.google_full_address) {
    return null;
  }

  const fullAddress = `${info.address.street}, ${info.address.postcode} ${info.address.city}`;
  const addressStr =
    product?.google_full_address?.length === 0
      ? fullAddress
      : product.google_full_address;
  const mapLink = createGoogleMapLink(product, addressStr);
  return (
    <div className="item-address">
      {showLabel && !mapOnly ? (
        <div className="label">{trans('map_address')}</div>
      ) : null}
      {!mapOnly ? (
        <>
          <div className="title is-5">
            {/*<span className={iconClass} /> */}
            {addressStr}
          </div>
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a
            className="link-to-map"
            target="_blank"
            href={mapLink}
            rel="noreferrer"
          >
            {trans('view_on_map')}
          </a>
        </>
      ) : null}

      {showMap || mapOnly ? (
        <div className="frame">
          <iframe
            className="lazy"
            title={product.name}
            data-src={`//www.google.com/maps/embed/v1/place?key=AIzaSyCUkQNg2UAbrh9LOkUMizBXchUScj1X5Y0&q=${addressStr}`}
            // data-src={`//maps.google.com/maps?q=${addressStr}&output=embed`}
            width="100%"
            height="350px"
            frameBorder="0"
            style={{ border: '0' }}
          />
        </div>
      ) : null}
    </div>
  );
}

AddressWithMapComp.defaultProps = {
  showMap: true,
  showLabel: true,
  iconClass: 'eb eb-map1 has-text-danger',
  mapOnly: false,
};

export const ProductAddressWithMap = connect(
  mapStateToProps,
  {},
)(AddressWithMapComp);
